import { Header } from "../../components/Header";

import { useContext, useEffect, useState } from "react";
import { Transactions } from "./Transactions";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../context/user-context/userContext";
import { Balance } from "./Balance";
import { AccountName } from "./AccountName";
import ClipLoader from "react-spinners/ClipLoader";
import { helpers } from "../../utils/helpers";
import { colors } from "../../utils/colors";
import * as R from "ramda";
import { Documents } from "../Documents/Documents";
import { Transfer } from "../Transfer/Transfer";
import { Helmet } from "react-helmet";
import { useFSNavigate } from "@fullstory/react-library";

export const AccountPage = () => {
    const structuredData = {
        "@context": "https://schema.org/",
        "@graph": [
            {
                "@type": "BankAccount",
                "name": "Select Platinum account",
                "offers": {
                    "@type": "Offer",
                    "eligibleCustomerType": "http://purl.org/goodrelations/v1#Enduser",
                    "priceSpecification": {
                        "@type": "PriceSpecification",
                        "priceCurrency": "GBP",
                        "price": "16",
                        "eligibleQuantity": {
                            "@type": "QuantitativeValue",
                            "value": "1",
                            "unitCode": "ANN"
                        }
                    },
                    "description": "You need to be aged 18 or over, and UK resident to apply.",
                    "offeredBy": {
                        "@type": "BankOrCreditUnion",
                        "@id": "http://rbs.co.uk",
                        "name": "RBS"
                    }
                },
                "feesAndCommissionsSpecification":
                    "http://personal.rbs.co.uk/content/dam/rbs_co_uk/currentaccounts/downloads/Reward/Personal%20and%20Private%20Current%20Account%20Fees%20and%20Interest%20Rates.pdf"
            }
        ]
    };

    // NAVIGATIONS
    const nav = useFSNavigate();
    const location = useLocation();

    // CONTEXT
    const userContext = useContext(UserContext);
    const { userId } = userContext;

    // STATES
    const [selected, setSelected] = useState<"account" | "documents" | "transfer">("account");
    const [loading, setLoading] = useState<boolean>(true);

    // useEffect
    useEffect(() => {
        const { pathname } = location;

        window.setTimeout(() => {
            if (pathname === "/account") {
                setSelected("account");
                setLoading(false);
            }
            if (pathname === "/documents") {
                setSelected("documents");
                setLoading(false);
            }
            if (pathname === "/transfer") {
                setSelected("transfer");
                setLoading(false);
            }
        }, helpers.RandomNumber(2000, 5000));
    }, [location]);

    // FUNCTIONS
    const changeSelected = (selected: "account" | "documents" | "transfer") => {
        if (!R.includes(selected, location.pathname)) {
            const pageName = selected.charAt(0).toUpperCase() + selected.slice(1).toLowerCase();

            nav(`/${selected}?user_id=${userId}`, pageName, { pageProperty: `${selected} property` });
            setSelected(selected);
            setLoading(true);
        }
    };

    return (
        <div>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            {loading && (
                <div
                    style={{
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}
                >
                    <ClipLoader size={100} color={colors.purple} />
                    <h3>loading...</h3>
                </div>
            )}

            {!loading && (
                <>
                    <Header />
                    <AccountName />
                    <Balance />

                    <div className="personal-nav-section">
                        <div className="personal-nav-contents">
                            <button
                                onClick={() => changeSelected("account")}
                                className={`personal-nav-buttons ${
                                    selected === "account" && "personal-nav-buttons_selected"
                                }`}
                                id="account-button"
                            >
                                Account
                            </button>
                            <button
                                className={`personal-nav-buttons ${
                                    selected === "documents" && "personal-nav-buttons_selected"
                                }`}
                                onClick={() => changeSelected("documents")}
                                id="documents-button"
                            >
                                Documents
                            </button>
                            <button
                                onClick={() => changeSelected("transfer")}
                                className={`personal-nav-buttons ${
                                    selected === "transfer" && "personal-nav-buttons_selected"
                                }`}
                                id="transfer-button"
                            >
                                Transfer/Pay
                            </button>
                        </div>
                    </div>

                    {selected === "account" && <Transactions />}
                    {selected === "documents" && <Documents />}
                    {selected === "transfer" && <Transfer />}
                </>
            )}
        </div>
    );
};
